export const userRoles = [ 
    'DCCPipelineGateAgent',
    'DccPrdPipelineStnAdmin',
    'DccPrdPinnacleOccStaff',
    'DccPrdRepublicAirlinesOccStaff',
    'DccPrdSkywestOccStaff',
    'DCC_Pipeline_Endeavor_OCC_OOOI_User',
    'DCC_Pipeline_SkyWest_OCC_Ops_Analyst_User',
    'DccPrdPipelineStnSupport',
    'DccPrdPipelineAdmin'
];

export const adminRoles = [ 
    'DccPrdPipelineAdmin'
];
